import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export default class CustomUrlSerializer implements UrlSerializer {
  private defaultUrlSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

  /**
   * 
   * @param url 
   * @returns 
   */
  parse(url: string): UrlTree {
    // Encode "+" to "%2B"
    url = url.replace(/\+/gi, '%2B');
    // Decode HTML-escaped "&amp;" separators so query params parse as "&".
    // The payment gateway redirects back with an HTML-escaped query string,
    // which would otherwise yield keys like "amp;fnolGuid" instead of "fnolGuid".
    url = url.replace(/&amp;/gi, '&');
    // Use the default serializer.
    return this.defaultUrlSerializer.parse(url);
  }

  /**
   * 
   * @param tree 
   * @returns 
   */
  serialize(tree: UrlTree): string {
    return this.defaultUrlSerializer.serialize(tree).replace(/\+/gi, '%2B');
  }
}